<template>
  <v-menu min-width="200px"
          :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <px-cancelar-dialog
        :titulo="getTitulo"
        :descricao="getDescricao"
        @cancelar-dialog="onMovimentar"/>
    </v-list>
    <px-confirm-dialog ref="confirm"/>
  </v-menu>
</template>

<script>
import CompraProdutoService from '@/modules/compra/compra-produto-service';

export default {
  props: {
    itemCompra: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    onMovimentar(motivoRecusa) {
      this.loading = true;
      CompraProdutoService.cancelarItemCompraProduto(this.itemCompra.id, { motivoRecusa })
        .then(() => {
          this.$toast('Item cancelado', { color: 'success' });
          this.$emit('update', this.itemCompra);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    getTitulo() {
      return 'Cancelar item';
    },
    getDescricao() {
      return `O item "${this.itemCompra.produto.descricao}" será cancelado e a operação não poderá ser desfeita.`;
    },
  },
};
</script>
